import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Car {
  id: string;
  brand: string;
  model: string;
  year: number;
  plateNumber: string;
  price: number;
  deposit: number;
  available: boolean;
  images: string[];
  features: string[];
  category?: string;
  fuelType?: string;
  transmission?: string;
  seats?: number;
  store?: any;
  company?: any;
  pricing?: {
    basePrice: number;
    deposit: number;
    total: number;
    duration: {
      days: number;
      hours: number;
    };
  };
}

interface RentalFilter {
  city: string;
  storeId: string;
  pickupDate: string;
  returnDate: string;
  returnToDifferentLocation: boolean;
}

interface RentalState {
  cars: Car[];
  selectedCar: Car | null;
  filter: RentalFilter;
  loading: boolean;
  error: string | null;
}

const initialState: RentalState = {
  cars: [],
  selectedCar: null,
  filter: {
    city: '',
    storeId: '',
    pickupDate: '',
    returnDate: '',
    returnToDifferentLocation: false,
  },
  loading: false,
  error: null,
};

const rentalSlice = createSlice({
  name: 'rental',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<Partial<RentalFilter>>) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    fetchCarsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCarsSuccess: (state, action: PayloadAction<Car[]>) => {
      state.loading = false;
      state.cars = action.payload;
    },
    fetchCarsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    selectCar: (state, action: PayloadAction<Car>) => {
      state.selectedCar = action.payload;
    },
    clearSelection: (state) => {
      state.selectedCar = null;
    },
  },
});

export const {
  setFilter,
  fetchCarsStart,
  fetchCarsSuccess,
  fetchCarsFailure,
  selectCar,
  clearSelection,
} = rentalSlice.actions;
export default rentalSlice.reducer;